import axios from 'axios';
import { loginService } from './LoginService';

export const bidingService = {
  getList,
  getBiddingCounts,
  getBiddingCategories,
  getActiveBidding,
  getLastWinningPrices,
  getSupplierAutocompleteOffers,
  postBid,
  bulkCreateBids,
  updateBid,
  deleteBid,
  scheduleBid,
  getOffers,
  rejectOffers,
  hideProduct,
  getHiddenProducts,
  unhideProduct,
  getRegisteredOffers
};
function getList(listToken) {
    let url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/by_token/${listToken}`;
  
    const requestOptions = {
      method: 'GET',
      url,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json'
      }
    }
    if (loginService.loggedIn()) {
      requestOptions.headers['Authorization'] = loginService.getToken();
    }
  
    return axios(requestOptions);
  }

  function getSupplierAutocompleteOffers(listToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/by_token/${listToken}/supplier_autocomplete_offers`;

    const requestOptions = {
      method: 'GET',
      url,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json'
      }
    };

    if (loginService.loggedIn()) {
      requestOptions.headers['Authorization'] = loginService.getToken();
    }

    return axios(requestOptions);
  }

  function getBiddingCounts(listToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/by_token/${listToken}/bidding_counts`;

    const requestOptions = {
      method: 'GET',
      url,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json'
      }
    };
    if (loginService.loggedIn()) {
      requestOptions.headers['Authorization'] = loginService.getToken();
    }

    return axios(requestOptions);
  }
  function getBiddingCategories(listToken, search = '') {
    const encodedSearch = encodeURIComponent(search || '');
    const searchQuery = encodedSearch ? `?search=${encodedSearch}` : '';
    const url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/by_token/${listToken}/categories${searchQuery}`;

    const requestOptions = {
      method: 'GET',
      url,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json'
      }
    };

    if (loginService.loggedIn()) {
      requestOptions.headers['Authorization'] = loginService.getToken();
    }

    return axios(requestOptions);
  }
  function getActiveBidding() {
    const url = `${process.env.REACT_APP_API_URL}/api/suppliers/active_bidding`;

    const requestOptions = {
      method: 'GET',
      url,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json'
      }
    };

    if (loginService.loggedIn()) {
      requestOptions.headers['Authorization'] = loginService.getToken();
    }

    return axios(requestOptions);
  }
  function getLastWinningPrices(listToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/by_token/${listToken}/last_winning_prices`;

    const requestOptions = {
      method: 'GET',
      url,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json'
      }
    };

    if (loginService.loggedIn()) {
      requestOptions.headers['Authorization'] = loginService.getToken();
    }

    return axios(requestOptions);
  }
  function postBid(listId, productData) {
    const url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/${listId}/necessity_list_items/${productData.idProduct}/supplier_bids`;
  
    const requestOptions = {
      method: 'POST',
      url,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      data: {
        bid: {
          price: productData.price,
          comment: productData.comment || ''

        }
      }
    };
  
    if (loginService.loggedIn()) {
      requestOptions.headers['Authorization'] = loginService.getToken();
    }
  
    return axios(requestOptions);
  }
function bulkCreateBids(listId, bids) {
  const url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/${listId}/supplier_bids/bulk_create`;

  const requestOptions = {
    method: 'POST',
    url,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    data: {
      bids: bids.map((bid) => ({
        necessity_list_item_id: bid.necessity_list_item_id,
        price: bid.price,
        comment: bid.comment || ''
      }))
    }
  };

  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}
  function updateBid(listId, necessityListItemId, bidId, bidData) {
    const url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/${listId}/necessity_list_items/${necessityListItemId}/supplier_bids/${bidId}`;

    const requestOptions = {
      method: 'PATCH',
      url,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      data: {
        bid: {
          price: bidData.price,
          comment: bidData.comment || ''
        }
      }
    };

    if (loginService.loggedIn()) {
      requestOptions.headers['Authorization'] = loginService.getToken();
    }

    return axios(requestOptions);
  }
  function deleteBid(listId, necessityListItemId, bidId) {
    const url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/${listId}/necessity_list_items/${necessityListItemId}/supplier_bids/${bidId}`;

    const requestOptions = {
      method: 'DELETE',
      url,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    };

    if (loginService.loggedIn()) {
      requestOptions.headers['Authorization'] = loginService.getToken();
    }

    return axios(requestOptions);
  }
  function scheduleBid(listId, programmedDate, options = {}) {
    const url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/${listId}/set_programmed`;
    const allSuppliers = options.allSuppliers ?? options.inviteAllSuppliers ?? true;
    const supplierIds = Array.isArray(options.supplierIds) ? options.supplierIds : [];
    const normalizedSupplierIds = supplierIds
      .map((supplierId) => Number(supplierId))
      .filter((supplierId) => Number.isInteger(supplierId));
  
    const requestOptions = {
      method: 'PATCH',
      url,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      data: {
        necessity_list: {
          programmed_date: programmedDate,
          all_suppliers: allSuppliers,
          supplier_ids: allSuppliers ? [] : normalizedSupplierIds
        }
      }
    };
  
    if (loginService.loggedIn()) {
      requestOptions.headers['Authorization'] = loginService.getToken();
    }
  
    return axios(requestOptions);
  }
  function getOffers(listId) {
    let url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/${listId}/bids_view`;
  
    const requestOptions = {
      method: 'GET',
      url,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json'
      }
    }
    if (loginService.loggedIn()) {
      requestOptions.headers['Authorization'] = loginService.getToken();
    }
  
    return axios(requestOptions);
  }
  function rejectOffers(productId, listId) {
    const url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/${listId}/refuse_offers`;
  
    const requestOptions = {
      method: 'POST',
      url,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      data:{
        id:listId,
        item_id:productId
      }
    };
  
    if (loginService.loggedIn()) {
      requestOptions.headers['Authorization'] = loginService.getToken();
    }
  
    return axios(requestOptions);
  }
  function hideProduct(listId, productId, productStatus) {
    const url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/${listId}/necessity_list_items/${productId}/supplier_product_preferences`;
  
    const requestOptions = {
      method: 'POST',
      url,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      data: {
        preference: {
          action: productStatus,
          reason: ''

        }
      }
    };
  
    if (loginService.loggedIn()) {
      requestOptions.headers['Authorization'] = loginService.getToken();
    }
  
    return axios(requestOptions);
  }
  function getHiddenProducts(listToken) {
    let url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/by_token/${listToken}/hidden_items`;
  
    const requestOptions = {
      method: 'GET',
      url,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json'
      }
    }
    if (loginService.loggedIn()) {
      requestOptions.headers['Authorization'] = loginService.getToken();
    }
  
    return axios(requestOptions);
  }
  function unhideProduct(listId, productId, productStatus) {
    const url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/${listId}/necessity_list_items/${productId}/supplier_product_preferences`;
  
    const requestOptions = {
      method: 'PUT',
      url,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      data: {
        preference: {
          action: productStatus,
          reason: ''

        }
      }
    };
  
    if (loginService.loggedIn()) {
      requestOptions.headers['Authorization'] = loginService.getToken();
    }
  
    return axios(requestOptions);
  }
  function getRegisteredOffers(listToken) {
    let url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/by_token/${listToken}/bid_items`;
  
    const requestOptions = {
      method: 'GET',
      url,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json'
      }
    }
    if (loginService.loggedIn()) {
      requestOptions.headers['Authorization'] = loginService.getToken();
    }
  
    return axios(requestOptions);
  }